import React, { useState } from "react";

import {
  CourtWrapper,
  CourtHeader,
  CourtHeaderButton,
  CourtTitle,
  Tabs,
  TabButton,
  NoMatches
} from "./court.styles";

import Match from "./Match";

import chevronDownWhite from "./imgs/chevron-down-white.svg";
import chevronUpWhite from "./imgs/chevron-up-white.svg";
import chevronDownBlack from "./imgs/chevron-down.svg";
import chevronUpBlack from "./imgs/chevron-up.svg";

const Court = ({ courtName, matches, isOdd, isExpanded }) => {
  const [activeTab, setActiveTab] = useState("ended");
  const [expandedWrapper, setExpandedWrapper] = useState(isExpanded || false);

  return (
    <CourtWrapper>
      <CourtHeader isOdd={isOdd}>
        <CourtTitle isOdd={isOdd}>{courtName}</CourtTitle>
        <CourtHeaderButton onClick={() => setExpandedWrapper(!expandedWrapper)}>
          {expandedWrapper ? (
            <img
              src={!isOdd ? chevronUpWhite : chevronUpBlack}
              alt="chevron-up"
            />
          ) : (
            <img
              src={!isOdd ? chevronDownWhite : chevronDownBlack}
              alt="chevron-down"
            />
          )}
        </CourtHeaderButton>
      </CourtHeader>
      {matches && expandedWrapper && (
        <>
          <Tabs>
            <TabButton
              active={activeTab === "ended"}
              onClick={() => setActiveTab("ended")}
            >
              Completed
            </TabButton>
            <TabButton
              active={activeTab === "live"}
              onClick={() => setActiveTab("live")}
            >
              Live
            </TabButton>
            <TabButton
              active={activeTab === "upcoming"}
              onClick={() => setActiveTab("upcoming")}
            >
              Upcoming
            </TabButton>
          </Tabs>
          {matches && matches[activeTab]?.length === 0 ? (
            <NoMatches>No matches to show</NoMatches>
          ) : (
            matches[activeTab]?.map((match, index) => (
              <Match key={index} match={match} courtName={courtName} />
            ))
          )}
        </>
      )}
      {!matches && expandedWrapper && <NoMatches>No matches to show</NoMatches>}
    </CourtWrapper>
  );
};

export default Court;
